import { render } from "./cp_score_type3.vue?vue&type=template&id=6cd9fe48&scoped=true"
import script from "./cp_score_type3.vue?vue&type=script&lang=js"
export * from "./cp_score_type3.vue?vue&type=script&lang=js"

import "./cp_score_type3.vue?vue&type=style&index=0&id=6cd9fe48&scoped=scoped&lang=css"

import exportComponent from "E:\\WorkCode\\HZYNew\\Code\\HZY.Student\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cd9fe48"]])

export default __exports__